// 高德地图设置
// export const AMAP_KEY = '36c66629fb61867ff02454961c464168'
// export const AMAP_SECRET = '942577874529a9508b82ad17fc615726'
export const AMAP_KEY = 'cfdffc08d50ae930d7c6544f172c85e2'
export const AMAP_SECRET = 'c7b038d3dca99102f47589d950cab6ea'
export const AMAP_PLUGINS = 'AMap.AutoComplete,AMap.Geolocation,AMap.Geocoder,AMap.PlaceSearch,AMap.DistrictSearch,AMap.Driving'